{
  "title": "FR Diagnostics",
  "description": "Look up one camper's facial-recognition tagging history for a camp and season.",
  "lookup": {
    "personIdLabel": "Person ID",
    "campIdLabel": "Camp ID",
    "seasonLabel": "Season",
    "submit": "Look up",
    "personIdRequired": "Enter a person ID as digits only.",
    "campIdRequired": "Enter a camp ID as digits only."
  },
  "states": {
    "idle": "Enter a person ID and a camp ID to get started.",
    "loading": "Loading tagging diagnostics…",
    "noTags": "This person has no published photo tags in any season for this camp.",
    "noSeasonData": "No published photo tags for the selected season."
  },
  "stats": {
    "heading": "Tagging",
    "photosTagged": "Photos tagged",
    "frTags": "By facial recognition",
    "manualTags": "Tagged manually",
    "note": "Counts cover published photos only — what camp families can actually see. A person can be tagged at most once per photo, so \"photos tagged\" is also the total tag count."
  },
  "training": {
    "heading": "Training photo",
    "trained": "Trained",
    "firstTrained": "First uploaded",
    "enrolledFaces": "Enrolled faces",
    "none": "No training photo has been uploaded for this person.",
    "imageAlt": "Facial recognition training photo",
    "imageFailed": "The training photo could not be loaded."
  },
  "photos": {
    "thumbnailAlt": "Tagged photo",
    "thumbnailFailed": "unavailable",
    "notLinkable": "no album link: this camp is not the one your session is scoped to",
    "note": "Showing up to 10 of the most recently added photos in each category. A thumbnail marked \"unavailable\" may be a deleted photo or a permission issue — the browser doesn't tell us which."
  },
  "closeCalls": {
    "heading": "Close calls",
    "description": "Photos where the tag that stuck is manual, but facial recognition also had an opinion.",
    "acceptedHeading": "Recognition accepted, but tagged manually",
    "acceptedDescription": "Facial recognition matched this camper on these photos, but a manual tag was already there — so the manual tag was applied before recognition finished.",
    "acceptedEmpty": "No photos where recognition was beaten by a manual tag.",
    "nearMissHeading": "Recognition near miss, tagged manually",
    "nearMissDescription": "Facial recognition scored this camper just under the threshold it applied and passed, so a person tagged the photo instead.",
    "nearMissEmpty": "No near misses for this season.",
    "columns": {
      "photo": "Photo",
      "album": "Album",
      "confidence": "Confidence",
      "threshold": "Threshold",
      "attempted": "Recognition ran",
      "taggedBy": "Tagged by"
    },
    "unknownTagger": "Not recorded",
    "acceptedInconclusive": "Can't tell whether recognition was beaten by a manual tag here — see the note above.",
    "nearMissInconclusive": "Can't tell whether recognition came close here — see the note above.",
    "coverage": {
      "unknown": "This version of the diagnostics service didn't report how much recognition data exists for these photos, so neither list below can be read as a finding. Reload in a few minutes — this usually means a deploy is still rolling out.",
      "noManualTags": "This camper has no manual tags in this season, so there is nothing to compare recognition against.",
      "noTelemetry": "Recognition has no recorded results for any of this camper's {total} manually tagged photos, so neither list below can be read as a finding. Two things cause this and the data can't tell them apart: recognition logging may not have been switched on for this camp yet, or no face was detected in the photo — which is itself a common reason a photo needed a manual tag.",
      "notACandidate": "Recognition scanned {scanned} of {total} manually tagged photos, but never considered this camper on any of them — so neither list below can be read as a finding. This usually means the training photo was enrolled after those photos were scanned; check the training date below.",
      "partial": "Recognition could only have matched this camper on {answerable} of {total} manually tagged photos, so the lists below may be incomplete."
    }
  }
}
